import React, { Component } from 'react';
import MathJax from 'react-mathjax2'

const tex = `P\\left(r \\right) = \\frac{\\left(1 + \\frac{M}{K} \\right)^{-K} \\cdot \\Gamma\\left(K + r \\right)}{\\Gamma\\left(r + 1 \\right)\\cdot \\Gamma\\left(K \\right)} \\cdot \\left(\\frac{M}{M+K} \\right)^r \\cdots \\left(1 \\right)`

class TestMathjax extends Component {
  render() {
    return (
      <div>
        <MathJax.Context input='tex'>
          <div>
            <MathJax.Node>{tex}</MathJax.Node>
          </div>
        </MathJax.Context>
      </div>
    )
  }

}

export default TestMathjax;
